/**
 * Organization logo rules (Admin → Organization, 2026-10-22). Mirrored by
 * storage.rules (organizations/{orgId}/branding): < 1 MB, PNG/JPEG/WebP/SVG.
 */
export const ORG_LOGO_MAX_BYTES = 1024 * 1024;

export const ORG_LOGO_TYPES: Record<string, string> = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/webp': 'webp',
  'image/svg+xml': 'svg',
};

export type OrgLogoError = 'type' | 'size' | 'svg-unsafe';

/**
 * An SVG is accepted only when it carries no active content: no <script>,
 * <foreignObject>, event-handler attributes (on…=) or javascript:/data:text
 * URLs. Refusing is safer than sanitizing — logos don't need any of it.
 */
export function isSafeSvg(text: string): boolean {
  return !/<script\b|<foreignObject\b|\son[a-z]+\s*=|javascript:|data:text\/html/i.test(text);
}

/** null when the file can be uploaded, else why not. `svgText` is required for SVG files. */
export function validateOrgLogo(file: { type: string; size: number }, svgText?: string): OrgLogoError | null {
  if (!ORG_LOGO_TYPES[file.type]) return 'type';
  if (file.size >= ORG_LOGO_MAX_BYTES) return 'size';
  if (file.type === 'image/svg+xml' && (svgText === undefined || !isSafeSvg(svgText))) return 'svg-unsafe';
  return null;
}

/** Storage path of a new logo upload — a fresh name each time so caches never show the old one. */
export function orgLogoPath(orgId: string, type: string, now: number): string {
  return `organizations/${orgId}/branding/logo-${now}.${ORG_LOGO_TYPES[type] ?? 'png'}`;
}
